import { useSelector } from 'react-redux';
import { authenticationTokenSelector } from '@cp/shared/api/core';
import { useEffect, useMemo } from 'react';
import { useSocketManager } from '@cp/shared/api/socket';

export const useSupportDialogSocket = () => {
  const authToken = useSelector(authenticationTokenSelector);
  const manager = useSocketManager();
  const socket = useMemo(() => manager.socket('/support-dialog', { auth: { token: authToken } }), [authToken, manager]);

  useEffect(() => {
    if (authToken && !socket.connected) {
      socket.connect();
    }
  }, [socket, authToken]);

  return socket;
};
